/**
 * @file DocumentPreviewModal.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-18
 * @modified 2026-09-18
 * @description A generated document, shown as it will print.
 *
 *              Wraps the shared ExportPreview, which is how every other export
 *              in this system previews: the server returns the SAME html string
 *              it hands to Puppeteer, and it is rendered in a sandboxed iframe
 *              at true page size. The document, not a drawing of it.
 *
 *              The earlier attempt here fetched the finished PDF and tried to
 *              open it — first in a new tab, which the browser blocks because
 *              the click that asked for it is over by the time the blob exists,
 *              then in an iframe, which leaves the viewer at the mercy of
 *              whatever the browser does with application/pdf. Neither was the
 *              pattern already in the codebase, and both failed quietly.
 */

import Modal from './Modal';
import ExportPreview from './ExportPreview';
import { useSlideOutButton } from './SlideOutButton';
import './DocumentPreviewModal.css';

function DocumentPreviewModal({ isOpen, endpoint, payload, title = 'Preview', onClose }) {
  useSlideOutButton([isOpen]);
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      className="document-preview"
      size="xl"
      footer={
        <div className="buttons slideout">
          <div>
            <button className="btn-slideout" onClick={onClose}>
              <div className="icon-wrapper"><span className="material-symbols-rounded">close</span></div>
              <span className="btn-label">Close</span>
            </button>
          </div>
        </div>
      }
    >
      {/* Many customers, many pages — the pane scrolls through all of them. */}
      <ExportPreview endpoint={endpoint} payload={payload} multiPage />
    </Modal>
  );
}

export default DocumentPreviewModal;
